import Marquee from "react-fast-marquee";
import { clients } from "@/data/resume";

export const ClientMarquee = () => {
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-b border-black/10 py-10 md:py-14"
    >
      <div className="mb-8 px-6 md:px-12">
        <span className="font-mono-x text-[11px] uppercase tracking-[0.3em] text-[#6E6D66]">
          Acted as Strategic Customer Success Partner to
        </span>
      </div>
      <Marquee speed={40} gradient gradientColor="#FBFAF7" gradientWidth={120}>
        {clients.map((c) => (
          <span
            key={c}
            className="mx-8 font-display text-4xl font-light uppercase tracking-tight text-transparent md:mx-12 md:text-6xl"
            style={{ WebkitTextStroke: "1px rgba(20,20,18,0.32)" }}
          >
            {c}
            <span className="ml-8 text-[#9A7526] md:ml-12" style={{ WebkitTextStroke: "0" }}>
              /
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
